import { render, staticRenderFns } from "./PieChartPlotly.vue?vue&type=template&id=3a906f4a&scoped=true&"
import script from "./PieChartPlotly.vue?vue&type=script&lang=js&"
export * from "./PieChartPlotly.vue?vue&type=script&lang=js&"
import style0 from "./PieChartPlotly.vue?vue&type=style&index=0&id=3a906f4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a906f4a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a906f4a')) {
      api.createRecord('3a906f4a', component.options)
    } else {
      api.reload('3a906f4a', component.options)
    }
    module.hot.accept("./PieChartPlotly.vue?vue&type=template&id=3a906f4a&scoped=true&", function () {
      api.rerender('3a906f4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/charts/PieChartPlotly.vue"
export default component.exports